export { default as I18nPropvider } from './provider';
export { LOCALES } from './constants';